import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="header">
      <h1 className="logo">NOVIONIX Labs</h1>
      <nav>
        <Link to="/" className="nav-link">Home</Link>
        <Link to="/solutions" className="nav-link">Solutions</Link>
        <Link to="/research" className="nav-link">Research</Link>
        <Link to="/team" className="nav-link">Team</Link>
        <Link to="/contact" className="nav-link">Contact</Link>
      </nav>
    </header>
  );
}
